import { useEffect, useMemo, useState } from 'react';
import { Outlet, useLocation, useSearchParams } from 'react-router-dom';
import useSubscriptionPlan from 'src/hooks/useSubscriptionPlan';
import SubscriptionExpiredModal from 'src/layouts/BlockingDialog';
import { cn } from 'src/utils/utils';

import { MobileHeader } from './components';
import { useSidebarState } from './hooks';
import SidebarV2Root from './index';

const SidebarV2Layout = () => {
  const sidebarState = useSidebarState();
  const { isMobile, isOpen, open } = sidebarState;
  const { isSubscriptionExpired, subscriptionExpiredAllowedPath } =
    useSubscriptionPlan();
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();

  const [isShareChatPath, setIsShareChatPath] = useState<boolean>(true);

  useEffect(() => {
    setIsShareChatPath(pathname.split('/').includes('share-chat'));
  }, [pathname]);

  const isWorkflowBuilder = useMemo(() => {
    const n = pathname.replace(/\/+$/, '') || '/';
    return (
      (n === '/workflows' || n.startsWith('/workflows/')) &&
      ((searchParams.get('workflow_id')?.trim() ?? '') !== '' ||
        (searchParams.get('wf')?.trim() ?? '') !== '')
    );
  }, [pathname, searchParams]);

  const hideGlobalSidebar = isShareChatPath || isWorkflowBuilder;
  const showFramedLayout = !isMobile && !isWorkflowBuilder && !isShareChatPath;

  return (
    <div
      className="tw:flex tw:h-screen tw:w-full tw:overflow-hidden"
      onDrop={(e) => e.preventDefault()}
      onDragOver={(e) => e.preventDefault()}
    >
      {!hideGlobalSidebar && <SidebarV2Root state={sidebarState} />}

      <main
        className={cn(
          'tw:relative tw:flex tw:min-w-0 tw:flex-1 tw:flex-col tw:bg-main tw:transition-all tw:duration-300 tw:ease-in-out',
          showFramedLayout && 'tw:p-m tw:pl-0'
        )}
      >
        {!hideGlobalSidebar && isMobile && !isOpen ? (
          <MobileHeader onOpenSidebar={open} />
        ) : null}
        <div
          className={cn(
            'tw:h-full tw:bg-primary tw:overflow-hidden tw:transition-all tw:duration-300 tw:ease-in-out',
            showFramedLayout && 'tw:rounded-l tw:shadow-e5'
          )}
        >
          <Outlet />
        </div>
        {isSubscriptionExpired &&
        pathname !== subscriptionExpiredAllowedPath ? (
          <SubscriptionExpiredModal open />
        ) : null}
      </main>
    </div>
  );
};

export default SidebarV2Layout;
